import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import classnames from 'classnames';
import { DropTarget } from 'react-dnd';
import { NavLink } from 'reactstrap';
import { useIntl } from 'react-intl';

import { getSidebarCurrentRoute, isArchive } from '../../helpers/App';
import { collectionsTarget } from '../../helpers/DNDCollections';
import ItemTypes from '../../helpers/DNDItemTypes';

const SidebarMyCollections = ({
  connectDropTarget,
  isOver,
  canDrop,
  location,
  onClick,
}) => {
  const intl = useIntl();

  return (
    connectDropTarget(
      <div
        className={classnames(
          'nav-item',
          'nav-item-my-collections',
          {
            hovered: isOver && canDrop,
            active: getSidebarCurrentRoute(location) === 'my-collections',
          },
        )}
      >
        <NavLink tag={Link} to={`${isArchive() ? '/archive' : ''}/collections/my`} onClick={onClick}>
          <i className="far fa-bookmark" />
          {intl.formatMessage({ defaultMessage: 'My Collections' })}
        </NavLink>
      </div>,
    )
  );
};

SidebarMyCollections.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  isOver: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  onClick: PropTypes.func,
};

export default withRouter(
  (DropTarget(ItemTypes.COLLECTION, collectionsTarget, (DNDconnect, monitor) => ({
    connectDropTarget: DNDconnect.dropTarget(),
    isOver: monitor.isOver(),
    canDrop: monitor.canDrop(),
  }))(SidebarMyCollections)),
);
